import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.306 9.67a9 9 0 0 1 15.059-4.035l1.9 1.9v-3.18a.75.75 0 1 1 1.5 0v4.993a.75.75 0 0 1-.75.75h-4.992a.75.75 0 1 1 0-1.5h3.183l-1.902-1.902a7.5 7.5 0 0 0-12.549 3.363.75.75 0 1 1-1.449-.388m16.857 3.739a.75.75 0 0 1 .53.92 9 9 0 0 1-15.058 4.035l-1.9-1.902v3.181a.75.75 0 0 1-1.5 0v-4.992a.75.75 0 0 1 .75-.75h4.992a.75.75 0 0 1 0 1.5H4.794l1.902 1.903a7.5 7.5 0 0 0 12.549-3.363.75.75 0 0 1 .918-.531"
    }, null, -1)
  ])))
}
export default { render: render }